export default {
  name: 'registry-template',
  translationKey: 'registry-template-module',
  routePrefix: 'registry-template',
  routeNamePrefix: 'admin.registry-template',
  directRoutesAvailable: false,
}
